import cs from 'classnames';
import Image from 'next/image';
import Link from 'next/link';
import React, { type FC } from 'react';
import { APPLICATION_TITLE, FILE_BROWSER_URL, LINKS } from '@/Module/Core/Constant';
import { useAppSelector } from '@/Module/Store/Hook';
const LogoMobile: FC = () => {
  const menuIsOpen = useAppSelector(state => state.layout.menuIsOpen);
  return <Link href={LINKS.HOME} className="relative z-50 flex flex-row items-center gap-3" data-sentry-element="Link" data-sentry-component="LogoMobile" data-sentry-source-file="LogoMobile.tsx">
      <Image width={40} height={32} src={`${FILE_BROWSER_URL}/img/img-logo.svg`} alt={APPLICATION_TITLE} className={cs('transition-all duration-300 ease-in-out', menuIsOpen ? 'rotate-0' : 'rotate-0')} data-sentry-element="Image" data-sentry-source-file="LogoMobile.tsx" />
    </Link>;
};
export default React.memo(LogoMobile);